import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.error.cause.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.error.to-string.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.concat.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.every.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.for-each.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';

function assignRef(ref, value) {
  if (ref == null) {
    return;
  }
  if (typeof ref === 'function') {
    ref(value);
  } else {
    try {
      ref.current = value;
    } catch (error) {
      throw new Error("Cannot assign value \"".concat(value, "\" to ref \"").concat(ref, "\""));
    }
  }
}
/**
 * Passes or assigns a value to multiple refs (typically a DOM node). Useful for
 * dealing with components that need an explicit ref for DOM calculations but
 * also forwards refs assigned by an app.
 *
 * @param refs Refs to fork
 */
function mergeRefs() {
  var refs = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    refs[_i] = arguments[_i];
  }
  if (refs.every(function (ref) {
    return ref == null;
  })) {
    return null;
  }
  return function (node) {
    refs.forEach(function (ref) {
      assignRef(ref, node);
    });
  };
}

export { assignRef, mergeRefs };
